// src/components/DownloadAppRedirect.jsx
import { useEffect } from "react";

const PLAY_URL = "https://play.google.com/store";
const APPSTORE_URL = "https://apps.apple.com";

/**
 * When this route is opened (e.g., by scanning the QR), we detect platform
 * and send the user to the appropriate store.
 */
export default function DownloadAppRedirect() {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);

    const url = isAndroid ? PLAY_URL : isIOS ? APPSTORE_URL : PLAY_URL;
    // Redirect immediately
    window.location.replace(url);
  }, []);

  return null; // nothing to render
}
